// 隐私声明
<template>
  <div>
    <!-- <Header /> -->
    <logo></logo>
    <div class="context">
      <div class="container-fluid">
        <h3 class="h3_title">隐私保护</h3>
        <div class="row law_detail">
          <div class="col-sm-8 col-sm-offset-2">
            <p class="i18n-bd">
              北京清大天达光电科技股份有限公司（以下简称“清大天达”）深知个人信息对您的重要性，我们将按照法律法规要求，采取相应安全保护措施，竭力确保您个人信息仅用于《隐私声明》条款中的用途。
            </p>
            <p class="i18n-bd">
              您浏览本网站时即表示同意清大天达对您登录时间、IP地址、访问次数、页面停留时间、关键词搜索等网站访问浏览信息及习惯进行收集、统计、分析和合理应用。
            </p>
            <p class="i18n-bd">我们可能将所收集到的信息用于以下用途：</p>
            <p class="i18n-bd">1、 提供您请求的服务或功能；</p>
            <p class="i18n-bd">2、 评估和分析市场、客户、产品及服务；</p>
            <p class="i18n-bd">
              3、
              了解用户使用我们服务的方式，以便我们改善服务并开发新产品和服务。
            </p>
            <p class="i18n-bd">
              当您通过清大天达公司的表单或投递功能，决定向清大天达提交您的个人信息时：
            </p>

            <p class="i18n-bd">
              1、
              您应当保证所填写的信息的合法性、真实性和完整性，并对您提交的个人信息的准确性负责；
            </p>
            <p class="i18n-bd">
              2、 您同意您的个人信息会被我们收集、分析和合理使用；
            </p>
            <p class="i18n-bd">
              3、
              您在本网站上填写的电话、邮箱，将视为同意接受清大天达与上述电话、邮箱联系或发送信息。您同意清大天达及下属子公司，就您可能会感兴趣的产品和服务与您联络(除非您已经表示不想收到该等讯息)；
            </p>
            <p class="i18n-bd">
              尽管我们在收取个人信息时已实施适当的安全措施，但是，目前经由互联网传递信息很难完全安全。我们尽力保护个人信息，却无法保证传送予我们或我们传送的信息的安全。您同意不会因此将信息泄露的责任归咎于清大天达。
            </p>
            <p class="i18n-bd">
              若您知悉我们的网站上有任何安全方面的漏洞,请及时联络我们,
              我们将立即采取措施予以解决。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import api from '@/utils/api'
import Logo from '../Index/Index_components/logo.vue'
export default {
  name: 'Privacy',
  components: {
    // Header,
    Logo,
  },

    
  data () {
    return {
      text: '清大天达隐私策略',
    }
  },
  methods: {},
}
</script>
<style scoped>
.bg {
  width: 46.875rem;
  height: 14.75rem;
}

/deep/ .context {
  width: 43.875rem;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10rem;
  font-size: 1.834rem;
  line-height: 3rem;
  margin-bottom: 6rem;
}
p{
  margin-top:2rem;
  text-indent: 3rem;
  text-align: justify; /*实现两端对齐*/
  text-justify: newspaper; /*通过增加或减少字或字母之间的空格对齐文本*/
  word-break: break-all; /*允许在单词内换行*/
}
.tabbar {
  margin-top: 24.125rem;
}
.h3_title{
  text-align: center;
}

</style>
